import React, { Fragment } from 'react'

import clsx from 'clsx'
import { isEmpty } from 'lodash'

import { Button, List, ListItem, ListItemText } from '@material-ui/core'
import { AlertDialog } from 'components'

import useStyles from './styles'

const FinalizeDialog = ({
  open,
  handleCloseFinalized,
  handleFinalize,
  pendingActivities = [],
}) => {
  const classes = useStyles()
  const hasPendingActivities = !isEmpty(pendingActivities)

  const content = (
    <Fragment>
      Tem certeza de que deseja finalizar?
      {hasPendingActivities ? (
        <Fragment>
          {' '}
          Foram identificadas pendências nos seguintes requisitos:
          <List dense disablePadding className={classes.listActivities}>
            {pendingActivities.map((activity) => (
              <ListItem
                className={classes.listItem}
                disableGutters
                key={activity?.id}
              >
                <ListItemText className={classes.listItemText}>
                  - {activity.name}
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </Fragment>
      ) : null}
      Após a finalização, não será possível voltar atrás. As respostas e
      evidências anexadas não poderão mais ser alteradas.
    </Fragment>
  )

  return (
    <AlertDialog
      open={open}
      onClose={handleCloseFinalized}
      variant="standard"
      severity={hasPendingActivities ? 'warning' : 'success'}
      title="Finalizar projeto de governança"
      content={content}
      dialogActions={
        <Fragment>
          <Button
            variant="outlined"
            color="primary"
            className={classes.outlinedSuccessButton}
            onClick={handleCloseFinalized}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={clsx({
              [classes.containerSuccessButton]: !hasPendingActivities,
              [classes.containerWarningButton]: hasPendingActivities,
            })}
            onClick={handleFinalize}
          >
            Finalizar
          </Button>
        </Fragment>
      }
    />
  )
}

export default FinalizeDialog
